import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sn-detection-image-dialog',
  templateUrl: './detection-image-dialog.component.html',
  styleUrls: ['./detection-image-dialog.component.scss'],
})
export class DetectionImageDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public url: string) {}

  public ngOnInit(): void {}
}
